import {React, styled} from 'common'
import {useNavigate} from 'services/hooks'
import {useI18n} from 'store/Store'
import {
    FormAdditionalButton,
    FormAdditionalText,
    FormRow,
} from 'components/Control/Form'

const RegisterRow = () => {
    const {i18n} = useI18n()
    const navigate = useNavigate()
    const translate = (label) => i18n.t('welcome.' + label)

    return (
        <RowContainer>
            <FormAdditionalText>{translate('newUser')}</FormAdditionalText>
            <FormAdditionalButton onClick={() => navigate('/register')}>
                {translate('register')}
            </FormAdditionalButton>
        </RowContainer>
    )
}

export default RegisterRow

const RowContainer = styled(FormRow)`
    width: 400px;
`
